export default __webpack_public_path__ + "static/media/ibtisam.2735a9cd.webp";